/*
 * @Description: 系统设置
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-08-04 10:31:14
 * @LastEditors: gao shuai
 */
import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* -----------------1.域名设置------------------- */
  // 域名列表
  async arealist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/GetCircuitByType',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 域名增加
  async areaadd(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/AddCircuit',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 域名编辑
  async areaedit(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/UpdateCircuit',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 域名移除
  async arearemove(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/DeleteCircuit',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 域名更改默认
  async areadefault(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/ChangeDefault',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 域名更改默认
  async areatest(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageCircuit/TestCircuit',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------2.代付配置------------------- */
  // 代付列表
  async paylist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePayForAnother/GetPayForAnotherPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代付添加
  async payadd(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePayForAnother/AddPayForAnother',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代付删除
  async paydelete(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePayForAnother/DeletePayForAnother',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代付信息
  async payinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePayForAnother/GetPayForAnother',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代付编辑
  async payedit(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePayForAnother/UpdatePayForAnother',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------3.资源上传------------------- */
  // // 上传地址
  // async uploadFileNew(params, type) {
  //   let header = await mgr();
  //   return api({
  //     url: '/api/Upload/UploadFile',
  //     method: 'post',
  //     data: params,
  //     headers: { Authorization: 'Bearer ' + header, ConfigKeyName: type }
  //   });
  // },
  // 上传地址
  async uploadFileNew(params, name, owner, userId = '0', remark = '') {
    let header = await mgr();
    return api({
      url: '/api/Upload/UploadFileNew',
      method: 'post',
      data: params,
      headers: {
        Authorization: 'Bearer ' + header,
        ConfigKeyName: name,
        OwnerType: owner,
        UserId: userId,
        Remark: remark
      }
    });
  },
  // 上传支付宝证书
  async uploadCert(params, userId = '0') {
    let header = await mgr();
    return api({
      url: '/api/Paid/UploadCert',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header, UserId: userId }
    });
  },
  // 上传信息
  async uploadinfo() {
    let header = await mgr();
    return api({
      url: '/api/Upload/GetConfig',
      method: 'get',
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------4.费率设置------------------- */
  // 费率列表
  async ratelist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/GetRankPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换默认状态
  async ratedefault(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/ChangeDefault',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除费率
  async ratedelete(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/DeleteRank',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 编辑获取费率
  async updateinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/GetUpdateProductRate',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 编辑获取费率
  async updaterate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/UpdateRank',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加获取费率列表
  async addinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/GetAddDefaultProductRate',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加费率
  async addrate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/AddRank',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------5.系统配置------------------- */
  // 系统配置信息
  async getSystemset(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/GetSystemSet',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取统计数据
  async getSysStatic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/GetIpsLogin',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 统计数据清理
  async clearSysStatic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ClearIpsLogin',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更新系统配置
  async updateSystem(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/UpdateSystemSet',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换结算类型
  async changeType(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeSettlementType',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换商户注册状态
  async changeRejister(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeRegisterState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换流量统计间隔时间
  async changeIptime(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeIpsTime',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  
  async changePlatOpenWxValidState(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangePlatOpenWxValid',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换登录器统计间隔时间
  async changeLogintime(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeLoginTime',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换登录器统计状态
  async changeLoginState(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeLoginState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 切换流量统计状态
  async changeIpState(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageSystemSet/ChangeIpsState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 上传微信二维码
  async uploadWeixin(params) {
    let header = await mgr();
    return api({
      url: '/api/Upload/UploadQrCodeFile',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
